import { webApiWithResponse } from "../../../../../core/http/httpThunks";
import { CommissionDetail } from "../../types";

export const updateCommissionDetailApi = (userId: string, attribute: CommissionDetail) =>
	webApiWithResponse<string>({
		method: "PUT",
		url: "listing/updcommdet",
		params: {
			userId
		},
		data: attribute
	});

export default updateCommissionDetailApi;
